import { createApp } from "vue";
import ColourRangeComponent from "./ColourRangeComponent.vue";
import BalloonTipFloating from "../../backend/components/topcer/plugins/balloonTipFloating";

const app = createApp({
  components: {
    "colour-range-component": ColourRangeComponent,

  },

});
app.directive('balloontip', BalloonTipFloating);
app.mount("#container-colour-range");
